import React from "react";
import ReactDOM from "react-dom/client";
import Login from "./components/login";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Gmac from "./components/gmac";
import Home from "./components/home";
import PrivateRoutes from "./components/privateRoutes";
import DataExplorer from "./components/orep";
import Emailr from "./components/emailr";
import EmailCron from "./components/emailcron";
const MPage = () => {
    return (
        <BrowserRouter>
            <Routes>
                {/* <Route path="/register" element={<Register />}></Route> */}
                {/* <Route path="/login" element={<Login />}></Route> */}
                <Route element={<PrivateRoutes />}>
                    <Route path="/mqtt" element={<Gmac />}></Route>
                </Route>
                <Route path="/" element={<Home />}></Route>
                <Route path="/login" element={<Login />}></Route>
                <Route path="/rep" element={<DataExplorer />}></Route>
                <Route path="/email" element={<Emailr />}></Route>
                <Route path="/emailcron" element={<EmailCron />}></Route>
            </Routes>
        </BrowserRouter>
    );
};

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(<MPage />);
